import TRAIcon from "../icons/TRAIcon";
import styles from "./shell.module.css";

/**
 * Circular primary + control for platform hub pill headers (Tournament / Organisation / …).
 * Place in `PlatformPageShell` `end`. Label is aria-only — icon is the visual.
 * Native button (not TRAButton) so `.btn` square radius cannot override the circle.
 *
 * @param {{
 *   label?: string,
 *   onClick?: () => void,
 *   "aria-label"?: string,
 *   disabled?: boolean,
 * }} props
 */
export default function PlatformHubCreateButton({
  label = "Create",
  onClick,
  "aria-label": ariaLabel,
  disabled = false,
}) {
  return (
    <button
      type="button"
      className={styles.hubCreateFab}
      aria-label={ariaLabel || label}
      disabled={disabled}
      onClick={onClick}
    >
      <TRAIcon name="plus" size="md" className={styles.hubCreateFabIcon} aria-hidden />
    </button>
  );
}
